export const spaceFn = ({ isFilterMode = false }) => ({ propertyValues, scope }) => {
  const pvs = propertyValues.filter((pv) => pv.property.uid === scope.property.uid);
  if (pvs.length === 0) {
    return false;
  }

  const selectedIds = pvs[0].spaces.map((o) => o.uid);
  if (scope.isEmpty) {
    return selectedIds.length === 0;
  }

  const neededIds = scope.spaces.map((o) => o.uid);
  if (neededIds.length === 0 && isFilterMode) {
    return true;
  }

  return neededIds.some((el) => selectedIds.indexOf(el) > -1);
};

export const directSpaceFn = ({ isFilterMode = false }) => ({ entity, scope }) => {
  let selectedSpaces = entity[scope.directProperty.edgeName];
  if (selectedSpaces === undefined) {
    return false;
  }
  if (selectedSpaces === null) {
    return scope.isEmpty === true;
  }
  if (!Array.isArray(selectedSpaces)) {
    selectedSpaces = [selectedSpaces];
  }

  if (scope.isEmpty) {
    return selectedSpaces.length === 0;
  }

  const selectedIds = selectedSpaces.map((o) => o.uid);
  const neededIds = scope.spaces.map((o) => o.uid);
  if (neededIds.length === 0 && isFilterMode) {
    return true;
  }

  return neededIds.some((el) => selectedIds.indexOf(el) > -1);
};
